export default {
  pay: "Pagar",
  acceptTermsAndConditions: "Aceptar Términos y condiciones",
  selectYourCard: "SELECCIONA TU TARJETA",
  yourOrder: "TÚ PEDIDO",
  generalPlaceHolderNotes:
    "Puedes quitar ingredientes, no puedes agregar o cambiar",
  placeholderNotesDrinks: "Comentarios ...",
  placeholderNotesFood: "Comentarios ...",
  total: "TOTAL:",
  totalToPay: "Total a pagar:",
  paymentConfirmation: "Confirmación de pago",
  paymentRequest: "Has solicitado el pago de:",
  payCash: "Pagar en efectivo",
  yourOrderIsInProgress: "Tú pedido está en curso,",
  itWillReachYou: "te llegará a la",
  desk: "mesa",
  paymentMethod: "METODO DE PAGO",
  dataphone: "Datáfono",
  smartphone: "Smartphone",
  howDoYouWantToPay: "¿Cómo quieres pagar?",
  creditOrDebitCard: "Tarjeta de crédito o débito",
  missingPay: "Falta Pagar:",
  petitionRejected: "Petición rechazada",
  redirectingToThePaymentprocess: "Redirigiendo al proceso de pago",
  addNewCard: "Agregar nueva tarjeta",
  paymentMade: "Pago Realizado",
  receiptOfYourPaymentTo: "Recibo de su pago a"
};
